<div class="purchse-container" fxLayout="column">
    <div ngClass.lt-md="mt-1" class="w-100" fxLayoutGap="10px" fxLayoutAlign="start center">
        <div fxHide.lt-md class="img-wrapper-item"></div>
        <div fxFlex="grow" fxLayout="column">
            <p class="about-buy" i18n>You are about to buy</p>
            <h3 class="m-0">ChatGPT Business Class</h3>
            <h3 class="mt-0 orange" fxLayoutGap="10px" fxLayout="row">
                <strong class="capitalize">{{ subscriptionPlan?.title }}</strong>
            </h3>
        </div>
        <div class="price-circle">
            <p class="m-0 white" i18n>Price</p>
            <h3 class="m-0 white">
                <span fxLayoutGap="5px" fxLayout="row" fxLayoutAlign="center center">
                    <strong>${{ subscriptionPlan?.priceInUsd }}</strong></span
                >
            </h3>
        </div>
    </div>
    <mat-horizontal-stepper class="purchase-stepper mt-1" linear #stepper>
        <mat-step [stepControl]="subscriptionPlanControl" label="Choose Plan" i18n-label="@@choosPlan">
            <div class="btn-group-wrapper" fxLayout="column">
                <mat-radio-group
                    fxLayout="column"
                    [formControl]="subscriptionPlanControl"
                    fxLayoutAlign="start center"
                    fxLayoutGap="20px"
                    class="pur-radio-group"
                >
                    <mat-radio-button
                        *ngFor="let subscriptionPlan of subscriptionPlans"
                        (click)="stepper.next()"
                        [value]="subscriptionPlan.id"
                    >
                        <div
                            fxLayout.lt-md="column-reverse"
                            fxLayoutAlign.lt-md="center center"
                            fxLayoutAlign="space-between start"
                            class="pur-pay-option-content"
                            fxLayoutGap.lt-md="10px"
                        >
                            <div class="main-info" fxLayout="column" fxLayoutGap="5px">
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <h3 class="m-0 capitalize">
                                        <strong>{{ subscriptionPlan.title }}</strong>
                                    </h3>
                                    <!-- <strong *ngIf="subscriptionPlan.recurring" class="ml-5 capitalize"
                                        >( {{ subscriptionPlan.recurring }}
                                        <span *ngIf="subscriptionPlan.max_users"
                                            >- {{ subscriptionPlan.max_users }}</span
                                        >)</strong
                                    > -->
                                </div>
                                <p>
                                    {{ subscriptionPlan.description }}
                                </p>
                            </div>

                            <div [ngStyle]="{ 'background-color': '#bfd8d0' }" class="saving-circle" fxLayout="column">
                                <h3 class="m-0 white">
                                    <strong>${{ subscriptionPlan.priceInUsd }}</strong>
                                </h3>
                            </div>
                        </div>
                    </mat-radio-button>
                </mat-radio-group>
                <button matStepperNext mat-raised-button color="primary" i18n="@@next">Next</button>
            </div>
        </mat-step>
        <mat-step label="Choose Method" i18n-label="@@choosMethod" [stepControl]="gatewayControl">
            <div class="btn-group-wrapper" fxLayout="column">
                <mat-radio-group
                    fxLayout="column"
                    [formControl]="gatewayControl"
                    fxLayoutAlign="start center"
                    fxLayoutGap="20px"
                    class="method-radio-group"
                >
                    <mat-radio-button
                        *ngFor="let option of paymentMethods"
                        [value]="option.name"
                        [disabled]="option.disabled"
                        (click)="stepper.next()"
                    >
                        <div
                            fxLayout.lt-md="column"
                            fxLayoutGap.lt-md="30px"
                            fxLayoutAlign="space-between center"
                            class="pur-pay-option-content"
                        >
                            <div fxLayout="column">
                                <h3 class="m-0 method-title">
                                    <strong>{{ option.title }}</strong>
                                </h3>
                            </div>
                            <div
                                class="method-logo"
                                [class.apple-logo-wrapper]="option.name === 'apple'"
                                fxLayout="column"
                            >
                                <img [src]="option.logo_url" />
                            </div>
                        </div>
                    </mat-radio-button>
                </mat-radio-group>
                <div fxLayout="row" fxLayoutGap="10px">
                    <button mat-button matStepperPrevious i18n="@@back">Back</button>
                    <button matStepperNext mat-raised-button color="primary" i18n="@@next">Next</button>
                </div>
            </div>
        </mat-step>
        <mat-step label="Payment" i18n-label="@@payment">
            <div class="pay-value">
                <span i18n>You are about to pay</span><span class="orange">${{ subscriptionPlan.priceInUsd }}</span>
                <span i18n> for a great learning experience. Please confirm.</span>
            </div>

            <div *ngIf="!(isLoading$ | async); else smallLoading" (click)="purchasePermission()">
                <app-purchase-manager
                    [gateway]="gatewayControl.value"
                    [ngClass]="{ 'block-purchase': !termsCheckControl.value }"
                    (paymentSucceeded)="paymentSucceeded.emit($event)"
                    [subscriptionPlanId]="subscriptionPlan?.id"
                ></app-purchase-manager>
            </div>
            <button matStepperPrevious mat-raised-button color="primary" i18n="@@back">Back</button>
        </mat-step>
    </mat-horizontal-stepper>
    <div class="faq-section"></div>
    <div class="rights">
        <mat-checkbox [formControl]="termsCheckControl" color="primary"
            ><span i18n
                >I accept KlickData's <span (click)="readMoreLink()" class="orange">terms of use</span></span
            ></mat-checkbox
        >
    </div>
</div>
<ng-template #smallLoading>
    <app-kd-logo-loading class="small-load-header" size="small"></app-kd-logo-loading>
</ng-template>
